import ExternalLink from "#components/util/ExternalLink";

export default function PBNote() {
	return (
		<small>
			Your PB is the combination of your best score and your best clear. Read more{" "}
			<ExternalLink href="https://docs.tachi.ac/wiki/pbs-scores/"> here</ExternalLink>.
		</small>
	);
}
